import {
  ConditionOperatorEnum,
  type Condition,
  type Control,
} from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';

import {
  ControlCreationFlow,
  type ControlEditState,
} from './ControlCreationFlow';

export interface ControlWizardProps {
  entity: Omit<Control, 'condition'> & { condition?: Condition };
  onSave: (control: Control) => Promise<void>;
  onAbort: () => void;
}

export function ControlWizard(props: ControlWizardProps) {
  const save = async (state: ControlEditState) => {
    await props.onSave({
      ...props.entity,
      name: state.name,
      condition: state.condition ?? {
        operator: ConditionOperatorEnum.And,
        conditions: [],
      },
      rules: state.rules,
      severity: state.severity,
    });

    return true;
  };

  return (
    <Wizard<ControlEditState>
      hideBackArrow={true}
      onAbort={props.onAbort}
      onFinish={save}
      flow={[ControlCreationFlow]}
      initialStep={{ stepIndex: props.entity.id ? 1 : 0 }}
      initialState={{
        id: props.entity.id,
        name: props.entity.name,
        condition: props.entity.condition,
        rules: props.entity.rules,
        severity: props.entity.severity,
      }}
      title={props.entity.id ? 'Edit Control' : 'Create Control'}
      stepperLabels={[]}
    />
  );
}
